module.exports = __webpack_public_path__ + "img/disaster_relief-gallery-2.33c4cbee.jpg";